import request from "@/utils/leafletRequest";
//获取活页式教材系统token
export function createPreviewSrc(data) {
  return request({
    url:
      "/textBook/createPreviewSrc?businessType=" +
      data.businessType +
      "&looseLeafId=" +
      data.looseLeafId +
      "&pageType=" +
      data.pageType +
      "&textBookId=" +
      data.textBookId +
      "&tyleType=B" +
      "&isTrial=" +
      data.isTrial,
    method: "POST",
    data: data,
  });
}
//查询教材详细信息
export function getTextBookInfo(textBookId) {
  return request({
    url: "/business/textBooks/getById?id=" + textBookId,
    method: "GET",
  });
}
//查询教材目录列表
export function getTextBookCatalog(textBookId, hiddenFlag) {
  return request({
    url:
      "/business/catalog/list?textBookId=" +
      textBookId +
      "&hiddenFlag=" +
      hiddenFlag,
    method: "GET",
  });
}
//查询教材中的活页信息
export function getTextBookLooseLeaf(textBookId) {
  return request({
    url: "/business/textBooks/getTextBookLooseLeaf?textBookId=" + textBookId,
    method: "GET",
  });
}

//查询活页信息
export function getLeaf(id) {
  return request({
    url: "/business/looseLeaf/getById",
    method: "GET",
    params: { id },
  });
}
